import { render, staticRenderFns } from "./ActionObjectValue.vue?vue&type=template&id=2ca5d470&"
import script from "./ActionObjectValue.vue?vue&type=script&lang=js&"
export * from "./ActionObjectValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports